import * as yup from 'yup';

// eslint-disable-next-line import/prefer-default-export
export const smartLockCodeSchema = yup.object().shape({
  code: yup.string().required().matches(/^\d+$/, 'code must be a number'),
  name: yup.string().required(),
});
